import { render, staticRenderFns } from "./StatesList.vue?vue&type=template&id=f97b83b2&"
import script from "./StatesList.vue?vue&type=script&lang=ts&"
export * from "./StatesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports